/**
 * @file chat-launcher-placement.ts
 * @description Где стоит кнопка «Сообщения» на странице магазина
 * (chat-window-design.md §9 вопрос 2, принято; SC64): обычно — в правом
 * нижнем углу, а на страницах, где угол занят своей панелью (конструктор
 * сайта), — значком в верхней панели. Страницы — реестром путей:
 * новая страница = новая строка.
 */

export type ChatLauncherPlacement = "fab" | "header";

/** Пути внутри магазина (без `/shop/:slug/`), где кнопка в верхней панели. */
const HEADER_PLACEMENT_PATHS: readonly RegExp[] = [
  // Конструктор сайта (phase19.16 Р1-6а): справа внизу — панель настроек, на
  // телефоне — «⋯» блоков и шторка. Чат — значком в верхней панели («[чат 3]»).
  /^site\/builder$/,
];

export function chatLauncherPlacement(relativePath: string): ChatLauncherPlacement {
  const path = relativePath.replace(/^\/+|\/+$/g, "");
  return HEADER_PLACEMENT_PATHS.some((re) => re.test(path)) ? "header" : "fab";
}
